import { connect } from 'react-redux';
import TwoPartyExchange from './TwoPartyExchange';
import {
  setDialogDetails,
  toggleTwoPartyExchange,
} from '../../../store/supplierAuthorizationSlice';

const mapDispatch = {
  setDialogDetails,
  toggleTwoPartyExchange,
};

export default connect(null, mapDispatch)(TwoPartyExchange);
